import { render, staticRenderFns } from "./userAnswerPC.vue?vue&type=template&id=35ec22c4&scoped=true&"
import script from "./userAnswerPC.vue?vue&type=script&lang=js&"
export * from "./userAnswerPC.vue?vue&type=script&lang=js&"
import style0 from "./userAnswerPC.vue?vue&type=style&index=0&lang=css&"
import style1 from "./userAnswerPC.vue?vue&type=style&index=1&id=35ec22c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec22c4",
  null
  
)

export default component.exports